<mode-status-banner
  class="published-banner"
  [ngClass]="{ published: fromReport }"
  status="warning"
  show-icon="true"
  layout="full-width"
>
  <span *ngIf="(datasetRepublishing$ | async) === false">This Dataset is published as a table in the data workspace. Changes to its structure or name will require manual updates to the table and may break content that's built on it.</span>
  <span *ngIf="datasetRepublishing$ | async">Published to the Data Workspace. Structural changes require republishing and may break dependent content.
    <a href="https://docs.thoughtspot.com/cloud/10.8.0.cl/analyst-studio-datasets" target="_blank"> how to manage changes </a>
  </span>
</mode-status-banner>
